import * as React from "react";
const SvgFolderOpen = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    viewBox="33 31 18 22"
    fill="none"
    {...props}
  >

    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={2}
      d="M35 49a2 2 0 0 1-2-2V37a2 2 0 0 1 2-2h4l2 2h4a2 2 0 0 1 2 2v1m-12 9h14a2 2 0 0 0 2-2v-5a2 2 0 0 0-2-2H39a2 2 0 0 0-2 2v5a2 2 0 0 1-2 2"
    />
  </svg>
);
export default SvgFolderOpen;
